import { constants } from '../constants/discovery';

export function updateSearchedSelectedInfluencerIds(searchedSelectedInfluencerIds) {
  return (dispatch) => {
    dispatch(update());
  };

  function update() {
    return {
      type: constants.UPDATE_SEARCHED_SELECTED_INFLUENCER_IDS,
      searchedSelectedInfluencerIds,
    };
  }
}
